import { filtersHelper } from '@/utils';

export const meetingRoomModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    logoUrl: data.logo_url,
    displayName: data.name,
    description: data.description,
    intro: data.intro,
    stockCode: data.stock_code,
    colorCode: data.color_code,
    websiteUrl: data.website_url,
    email: data.email,
    phoneCode: data.phone_code,
    phoneIso: data.phone_iso,
    phoneNumber: data.phone_number,
    startOperateTime: data.start_operate_time,
    endOperateTime: data.end_operate_time,
    isListed: data.is_listed,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    meetingRooms: (data.meeting_rooms ?? []).map(item => ({
        uuid: item.uuid,
        code: item.code,
        name: item.name,
        capacity: item.capacity,
        image: item.image,
        description: item.description,
        link: item.link,
        isServeDeck: item.is_serve_deck,
        isActive: item.is_active,
        images: (item.images ?? []).map(item => ({
            uuid: item.uuid,
            url: item.url,
            isMainImage: item.is_main_image,
        })),
        createdAt: filtersHelper.getDateFormat(item.created_at),
        createdBy: item.created_by,
        updatedAt: filtersHelper.getDateFormat(item.updated_at),
        updatedBy: item.updated_by,
        amenities: (item.amenities ?? []).map(item => ({
            uuid: item.uuid,
            name: item.name,
            icon: item.aircond,
            imageUrl: item.image_url,
            sequence: item.sequence,
            isActive: item.isActive,
            createdAt: filtersHelper.getDateFormat(item.created_at),
            createdBy: item.created_by,
            updatedAt: filtersHelper.getDateFormat(item.updated_at),
            updatedBy: item.updated_by,
            deletedAt: filtersHelper.getDateFormat(item.deleted_at),
            deletedBy: item.deleted_by,
        })),
    })),
});